import { DateRanges } from '../DateRanges';
import { PHODPageData, getWindow } from '../general';
import { IPHRequest, ISessionPHFilter } from '../../models/purchase-history';
import { IOPExpSessionData, TDateSelectValues } from '../../models/common';

interface initPHRequestBuilderProps {
  customerType: string;
  customerRole: string;
  searchParams: URLSearchParams;
  dateSelectorValue: TDateSelectValues;
  svocID: string;
  initResultsFilter: 'allOrders' | 'myOrders';
}

export const initPHRequestBuilder = ({
  customerType,
  customerRole,
  searchParams,
  dateSelectorValue,
  svocID,
  initResultsFilter,
}: initPHRequestBuilderProps): IPHRequest => {
  const OPExpSessionData = PHODPageData();

  const createInitSearchBy = () => {
    if (
      searchParams.get('requestSearchSelectorValue') &&
      searchParams.get('requestSearchCriteria')
    ) {
      const criteria = searchParams.get('requestSearchSelectorValue') || '';
      const value = searchParams.get('requestSearchCriteria') || '';
      const initSearchBy = { [criteria]: value };
      return [initSearchBy];
    }
    return undefined;
  };
  if (customerType === 'b2b' || customerRole !== '') {
    return {
      pageSize: 20,
      pageNumber: (OPExpSessionData as IOPExpSessionData)?.lastPage ?? 1,
      startDate:
        searchParams.get('startDate') ||
        DateRanges[dateSelectorValue].startDate,
      endDate:
        searchParams.get('endDate') || DateRanges[dateSelectorValue].endDate,
      customerAccountId: svocID || '',
      sortBy: 'salesDate',
      sortOrder: 'desc',
      searchType: 'ORDERS',
      resultsFilter: initResultsFilter,
      searchBy: createInitSearchBy(),
    };
  }
  return {
    pageSize: 20,
    pageNumber: (OPExpSessionData as IOPExpSessionData)?.lastPage ?? 1,
    startDate: DateRanges[dateSelectorValue].startDate,
    endDate: DateRanges[dateSelectorValue].endDate,
  };
};

export const formatDate = (dateStr: string) => {
  if (!dateStr) return dateStr;
  const [part1, part2, part3] = dateStr.split('/');

  if (dateStr.includes('-')) return dateStr;

  if (part1 && part2 && part3) {
    return `${part3}-${part1.padStart(2, '0')}-${part2.padStart(2, '0')}`;
  }
  return dateStr;
};

export const getFilterDetailsFromSession = () => {
  const phFilter = getWindow()?.sessionStorage?.getItem('PHFilter');
  return phFilter ? JSON.parse(phFilter) : undefined;
};

export const getEffectiveFilterDateRange = (
  pHRequest: IPHRequest,
  sessionPHFilter: ISessionPHFilter | undefined,
) => {
  const startDate = pHRequest?.startDate?.split('-');
  const endDate = pHRequest?.endDate?.split('-');
  if (sessionPHFilter?.startDate && sessionPHFilter?.endDate) {
    return {
      startDate: sessionPHFilter.startDate,
      endDate: sessionPHFilter.endDate,
    };
  }
  if (startDate?.length === 3 && endDate?.length === 3) {
    return {
      startDate: `${startDate[1]}/${startDate[2]}/${startDate[0]}`,
      endDate: `${endDate[1]}/${endDate[2]}/${endDate[0]}`,
    };
  }
  return {
    startDate: '',
    endDate: '',
  };
};
